import CallCentreApi from '@/api/CallCentreApiAxiosPlugin'

export default class PhotosController {
  public static async GetThumbnailUrl(jobId: string, photoId: string): Promise<string> {
    const res = await CallCentreApi.get<string>(`photos/${jobId}/${photoId}/thumbnail-url`)
    return res.data ? res.data : ''
  }
}
